import { Filter } from "../models/filter-models";
import { Color } from "../models/enums";
import { Tier } from "../models/item-data-models";

export function getTierColor(filter: Filter, tier: Tier | undefined, divCard: boolean = false, cosmeticsKey: 'tierCosmetics' | 'divCardTierCosmetics' | 'equipmentTierCosmetics' = 'tierCosmetics'): string {
  if (!tier) return 'visible';
  const cosmetics = cosmeticsKey === 'divCardTierCosmetics' ? filter.divCardTierCosmetics
    : cosmeticsKey === 'equipmentTierCosmetics' ? filter.equipmentTierCosmetics
    : divCard ? filter.divCardTierCosmetics : filter.tierCosmetics;
  const tierCosmetic = cosmetics.find(t => t.tier === tier);
  if (!tierCosmetic) return 'visible';
  return 'tier-' + ((tierCosmetic.displayOptions.cosmeticOptions?.highlight && tierCosmetic.displayOptions.cosmeticOptions?.highlightColor)
    ? tierCosmetic.displayOptions.cosmeticOptions?.highlightColor?.toLocaleLowerCase()
    : tierCosmetic.displayOptions.hidden ? 'hidden' : 'visible') + '-color';
}

export function getTierDescription(filter: Filter, tier: Tier | undefined, short: boolean = false, divCard: boolean = false): string {
  if (!tier) return 'visible';
  const tierCosmetic = (divCard ? filter.divCardTierCosmetics : filter.tierCosmetics).find(t => t.tier === tier);
  if (!tierCosmetic) return 'Unknown';

  if (!tierCosmetic.displayOptions.active) {
    return 'Disabled (visible)';
  } else if (tierCosmetic.displayOptions.hidden) {
    return 'Hidden';
  } else {
    return (tierCosmetic.displayOptions.cosmeticOptions?.highlight
      ? (tierCosmetic.displayOptions.cosmeticOptions?.highlightColor + (short ? '' : ' highlight' ) )
      : 'Visible' + (short ? '' : ', no highlight'));
  }
}

export function getHighlightColor(color: Color) {
  return tierStyleMap.get(color);
}

export const tierStyleMap = new Map<Color, string>([
  [Color.Red, 'tier-red'],
  [Color.Green, 'tier-green'],
  [Color.Blue, 'tier-blue'],
  [Color.Brown, 'tier-brown'],
  [Color.White, 'tier-white'],
  [Color.Yellow, 'tier-yellow'],
  [Color.Cyan, 'tier-cyan'],
  [Color.Grey, 'tier-grey'],
  [Color.Orange, 'tier-orange'],
  [Color.Pink, 'tier-pink'],
  [Color.Purple, 'tier-purple']
]);

export function socketGroupKeyDown(event: KeyboardEvent) {
  const allowedChars = /^[RGBWXT]$/;
  const char = event.key;

  // Allow navigation keys (arrows, backspace, delete, etc.)
  if (event.ctrlKey || event.altKey || event.metaKey ||
    char.length > 1 || char === 'Backspace' || char === 'Delete' ||
    char === 'ArrowLeft' || char === 'ArrowRight' ||
    char === 'Tab' || char === 'Home' || char === 'End') {
    return;
  }

  // Prevent input of disallowed characters
  if (!allowedChars.test(char)) {
    event.preventDefault();
  }
}
